export default __webpack_public_path__ + "static/media/a1.352b2ffb.png";